import React, { useState } from 'react';

/**
 * Renders a YouTube/video thumbnail with fallback when the image 404s.
 * YouTube thumbnail URLs (e.g. i.ytimg.com/vi/VIDEO_ID/mqdefault.jpg) can return 404 for some videos.
 */
export default function VideoThumbnail({ src, alt, className = '', videoId, placeholderClassName = '' }) {
  const [failed, setFailed] = useState(false);

  if (!src && !videoId) return null;

  const url = src || (videoId ? `https://img.youtube.com/vi/${videoId}/mqdefault.jpg` : null);
  if (!url) return null;

  if (failed) {
    return (
      <div
        className={`bg-slate-600 flex items-center justify-center text-slate-400 ${className}`}
        aria-label={alt}
      >
        <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
          <path d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" />
        </svg>
      </div>
    );
  }

  return (
    <img
      src={url}
      alt={alt}
      className={className}
      onError={() => setFailed(true)}
    />
  );
}
